import { http } from '@/utils/http';

export const getBanner = async function(params = {}) {
  const url = '?r=banner/index';
  const { data } = await http(url, params, 'GET');
  return data;
}

export const getIndexServer = async function(params = {}) {
  const url = '?r=home/index';
  const { data } = await http(url, params, 'GET');
  return data;
}


// WEBPACK FOOTER //
// ./src/server/index.js